export default function VisitSection() {
  return (
    <section id="visit" className="w-full bg-[#F7F5F2] py-20 md:py-28 lg:py-32">
      <div className="w-full px-6 md:px-10 lg:px-16 max-w-6xl mx-auto">

        <p
          className="text-[11px] uppercase tracking-[0.22em] text-[#6C7278] mb-4"
          style={{ fontFamily: "'Space Grotesk', sans-serif" }}
        >
          / Contact Us
        </p>
        <h2
          className="text-3xl md:text-4xl lg:text-[48px] font-extrabold text-[#1A1C1E] tracking-[-0.02em] leading-tight mb-12 md:mb-16"
          style={{ fontFamily: "'Public Sans', sans-serif" }}
        >
          Let&apos;s Build Something
          <br />
          <span className="text-[#6C7278] font-light">Great Together</span>
        </h2>

        <div className="flex flex-col lg:flex-row gap-px bg-[#E2DED9]">

          {/* Info panel */}
          <div className="w-full lg:w-[380px] flex-shrink-0 bg-[#F7F5F2] p-8 md:p-10 flex flex-col gap-8">

            {/* Address */}
            <div>
              <p
                className="text-[10px] uppercase tracking-[0.18em] text-[#6C7278] mb-3"
                style={{ fontFamily: "'Space Grotesk', sans-serif" }}
              >
                Headquarters
              </p>
              <p
                className="text-base font-semibold text-[#1A1C1E] leading-snug"
                style={{ fontFamily: "'Public Sans', sans-serif" }}
              >
                International House
              </p>
              <p
                className="text-sm text-[#6C7278] mt-1"
                style={{ fontFamily: "'Public Sans', sans-serif" }}
              >
                12 Constance Street, London
              </p>
              <p
                className="text-sm text-[#6C7278]"
                style={{ fontFamily: "'Public Sans', sans-serif" }}
              >
                E16 2DQ, United Kingdom
              </p>
            </div>

            {/* Contact */}
            <div className="h-px bg-[#E2DED9]" />

            <div>
              <p
                className="text-[10px] uppercase tracking-[0.18em] text-[#6C7278] mb-3"
                style={{ fontFamily: "'Space Grotesk', sans-serif" }}
              >
                Get in Touch
              </p>
              <a
                href="tel:+447520658798"
                className="flex items-center gap-2 text-sm text-[#1A1C1E] hover:text-[#B8422E] transition-colors mb-2"
                style={{ fontFamily: "'Public Sans', sans-serif" }}
              >
                <i className="ri-phone-line text-[#B8422E]" />
                +44 7520 658798
              </a>
              <a
                href="mailto:support@trevionics.com"
                className="flex items-center gap-2 text-sm text-[#1A1C1E] hover:text-[#B8422E] transition-colors"
                style={{ fontFamily: "'Public Sans', sans-serif" }}
              >
                <i className="ri-mail-line text-[#B8422E]" />
                support@trevionics.com
              </a>
            </div>

            {/* CTA */}
            <a
              href="/contact"
              className="inline-flex items-center justify-center gap-2 w-full py-3 bg-[#1A1C1E] text-white text-[12px] font-semibold hover:bg-[#B8422E] transition-colors duration-300 whitespace-nowrap"
              style={{ fontFamily: "'Space Grotesk', sans-serif", borderRadius: "4px" }}
            >
              <i className="ri-mail-send-line" />
              Start a Project
            </a>
          </div>

          {/* Map */}
          <div className="flex-1 min-h-[400px] lg:min-h-[500px] overflow-hidden">
            <iframe
              title="Trevionix LTD Location"
              src="https://maps.google.com/maps?q=International+House%2C+12+Constance+Street%2C+London+E16+2DQ&t=&z=15&ie=UTF8&iwloc=&output=embed"
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: "400px", filter: "grayscale(20%) contrast(1.05)" }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
